import type { Theme } from '@mui/material/styles'

const MuiTabs = (baseTheme: Theme) => ({
  defaultProps: {
    centered: true,
  },
  styleOverrides: {
    root: {
      '& .MuiTabs-indicator': {
        display: 'none',
      },
      '& .MuiTabs-flexContainer': {
        columnGap: baseTheme.spacing(0.5),
      },
    },
  },
})

export default MuiTabs
